import React from 'react'
import PropTypes from 'prop-types'
import HeadingAlpha from '../headings/heading-alpha'
import InfoBlock from '../texts/info-block'
import Label from '../texts/label'

const PickupOptions = props => {
  const {
    hasPickUpAtCharityOption,
    hasPickUpAtEventOption,
    hasHomeDeliveryOption,
    pickUpAtEventDatetime,
    shippingOptionsTitleText,
    pickUpAtEventTitleText,
    pickUpAtEventInfoText,
    pickUpAtCharityTitleText,
    pickUpAtCharityInfoText,
    shippingOptionTitleText,
    shippingOptionInfoText
  } = props
  return (
    <div className='modal-main'>
      <HeadingAlpha className='bottom-space'>
        {shippingOptionsTitleText}
      </HeadingAlpha>
      {hasPickUpAtEventOption && (
        <InfoBlock>
          <Label shyLabel>{pickUpAtEventTitleText}</Label>
          <p>{pickUpAtEventInfoText + pickUpAtEventDatetime}</p>
        </InfoBlock>
      )}
      {hasPickUpAtCharityOption && (
        <InfoBlock>
          <Label shyLabel>{pickUpAtCharityTitleText}</Label>
          <p>{pickUpAtCharityInfoText}</p>
        </InfoBlock>
      )}
      {hasHomeDeliveryOption && (
        <InfoBlock>
          <Label shyLabel>{shippingOptionTitleText}</Label>
          <p>{shippingOptionInfoText}</p>
        </InfoBlock>
      )}
    </div>
  )
}

PickupOptions.propTypes = {
  hasPickUpAtCharityOption: PropTypes.bool.isRequired,
  hasPickUpAtEventOption: PropTypes.bool.isRequired,
  hasHomeDeliveryOption: PropTypes.bool.isRequired,
  pickUpAtEventDatetime: PropTypes.string,
  // translations
  shippingOptionsTitleText: PropTypes.string.isRequired,
  pickUpAtEventTitleText: PropTypes.string.isRequired,
  pickUpAtEventInfoText: PropTypes.string.isRequired,
  pickUpAtCharityTitleText: PropTypes.string.isRequired,
  pickUpAtCharityInfoText: PropTypes.string.isRequired,
  shippingOptionTitleText: PropTypes.string.isRequired,
  shippingOptionInfoText: PropTypes.string.isRequired
}

export default PickupOptions



// WEBPACK FOOTER //
// ./src/ui/views/pickup-options.js